import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, Optional, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { DataTaskService } from '@app/core/services/data-task.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { catchError, EMPTY, from, ReplaySubject, Subject, switchMap, takeUntil } from 'rxjs';

@Component({
    selector: 'tt-deviant-vat',
    templateUrl: './deviant-vat.component.html',
    styleUrls: ['./deviant-vat.component.css'],
})
export class DeviantVatComponent implements OnInit, OnChanges, OnDestroy {
    @Input()
    public params?: GetDeviantVatParams;

    public params$ = new ReplaySubject<GetDeviantVatParams>(1);

    public destroy$ = new Subject<void>();

    public get?: DeviantVatGet;

    public grid?: GridOptions;

    constructor(
        private datatask: DataTaskService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);

        this.params$
            .pipe(
                takeUntil(this.destroy$),
                switchMap((params) => from(this.getDeviantVat(params)).pipe(catchError((err) => EMPTY))),
            )
            .subscribe({
                next: (get) => {
                    this.get = get;
                    this.navigator?.setHeading?.(this.get?.heading ?? '');
                },
            });
    }

    private readGrid() {
        if (!this.grid) {
            this.grid = new Grid().setRememberId('deviantvat.grid').setLoadDataFunction({ method: 3731, parameters: () => this.params });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async getDeviantVat(params: GetDeviantVatParams) {
        return (await this.datatask.Post(3730, params))[0];
    }

    private init(params: GetDeviantVatParams) {
        this.params$.next(params);
        this.readGrid();
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.params = this.navigator.params as any;
            this.init(this.params!);
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['params']) {
            this.init(changes['params'].currentValue);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        this.params$.complete();
    }
}

interface DeviantVatGet {
    heading: string;
}

interface GetDeviantVatParams {
    prod_id: string;
}
